import React from "react";
import styled from "styled-components";

import LineSeedKrRg from "../../../../atoms/text/lineSeedKr/lineSeedKrRg";

const LSRgCaption03 = (props) => {
  return <LSRgCaption03Wrapper {...props} />;
};

export default LSRgCaption03;

const LSRgCaption03Wrapper = styled(LineSeedKrRg)`
  font-size: 13px;
  font-weight: 400;
  line-height: 15.6px;
  letter-spacing: -0.3px;

  color: #222222;
`;
